document.addEventListener('DOMContentLoaded', () => {
	var wrappers = document.querySelectorAll('.atk-nardi-product-design .items');

	if (wrappers.length > 0) {
		wrappers.forEach((wrapper) => {
			
			var items = wrapper.querySelectorAll('.item');
			
			if (items.length > 0) {
				var delay = 1300;
				window.utils.forEach(items, function (index, item) {

					item.classList.add('active-transition');

					var text = item.querySelector('.text'),
						line = item.querySelector('.lin'),
						circle = item.querySelector('.circle');

					if (text && line && circle) { 
						setTimeout(() => {
							circle.classList.add('active');
							setTimeout(() => {
								line.classList.add('active');
							}, 500 );
							setTimeout(() => {
								text.classList.add('active');
							}, 1100 );
						}, (index * 700 + delay) );
						delay = delay + 700;
					}
				});
			}
		});
	}
});